import React from 'react';
import { Wrapper, Heading, HeadingTitle, HeadingDescription, Partnership, MainPartnership, MainPartnershipImage, MoreOnTheWayTitle, PartnershipImage, PartnershipTitle, PartnershipSubtitle, PartnershipDescription, PartnershipLink, PartnershipsSection } from './index.styled';
import Fade from 'react-reveal/Fade';
import { useTranslation } from 'react-i18next';
import { useMobileBreakpoint } from '../breakpoints';
import mobileHebei from './img/bicycle-steve-mobile.jpg';
import deskHebei from './img/bicycle-steve.jpg';
const CONTENT_PATH = 'AboutUsPage.Partnership';

export const Partnerships = () => {
  const { t } = useTranslation();
  const isMobile = useMobileBreakpoint();
  const mainImg = isMobile ? mobileHebei : deskHebei;
  const partnerships = t(`${CONTENT_PATH}.partnerships`, { returnObjects: true })

  return (
    <Fade up>
    <Wrapper id='partnership'>
        <Heading>
          <HeadingTitle>{t(`${CONTENT_PATH}.heading.title`)}</HeadingTitle>
          <HeadingDescription>{t(`${CONTENT_PATH}.heading.description`)}</HeadingDescription>
        </Heading>
        <PartnershipsSection>
            <MainPartnership>
              <MainPartnershipImage>
                <img src={mainImg} alt='' role='presentation' />
              </MainPartnershipImage>
              <PartnershipSubtitle>{partnerships[0].licensingType}</PartnershipSubtitle>
              <PartnershipTitle>{partnerships[0].title}</PartnershipTitle>
              <PartnershipDescription>{partnerships[0].description}</PartnershipDescription>
              <PartnershipLink href={partnerships[0].url} target={`_Blank`}>{partnerships[0].cta}</PartnershipLink>
            </MainPartnership>
            <Partnership>
              <PartnershipImage>
                <img src={require(`${partnerships[1].img}`).default} alt='' role='presentation' />
              </PartnershipImage>
              <MoreOnTheWayTitle>
                <PartnershipTitle>{partnerships[1].title.toUpperCase()}</PartnershipTitle>
              </MoreOnTheWayTitle>
              <PartnershipDescription>{partnerships[1].description}</PartnershipDescription>
            </Partnership>
        </PartnershipsSection>
    </Wrapper>
    </Fade>
  )
}